"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _tokens = _interopRequireDefault(require("@paprika/tokens"));

var _PopoverContext = _interopRequireWildcard(require("../../PopoverContext"));

var _Tip = require("./Tip.styles");

var propTypes = {
  /** Number setting the z-index */
  zIndex: _propTypes["default"].number
};
var defaultProps = {
  zIndex: null
};

function Tip(props) {
  var zIndex = props.zIndex,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["zIndex"]);

  var isDark = _react["default"].useContext(_PopoverContext.ThemeContext);

  var _React$useContext = _react["default"].useContext(_PopoverContext["default"]),
      content = _React$useContext.content,
      tip = _React$useContext.tip,
      refTip = _React$useContext.refTip,
      isOpen = _React$useContext.isOpen,
      isPortal = _React$useContext.isPortal,
      portalElement = _React$useContext.portalElement;

  var borderColor = isDark ? _tokens["default"].color.black : _tokens["default"].border.color;
  var backgroundColor = isDark ? _tokens["default"].color.black : _tokens["default"].color.white;

  var TipStyledComponent = /*#__PURE__*/_react["default"].createElement(_Tip.TipStyled, (0, _extends2["default"])({
    isOpen: isOpen,
    "data-pka-anchor": "popover.tip",
    ref: refTip,
    rotate: tip.rotate,
    style: {
      left: tip.x,
      top: tip.y
    },
    zIndex: zIndex || content.zIndex
  }, moreProps), /*#__PURE__*/_react["default"].createElement("svg", {
    height: "100%",
    width: "100%",
    viewBox: "0 0 12 12",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "0 12 12 12 6 6",
    fill: borderColor
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "1 12 11 12 6 7",
    fill: backgroundColor
  })));

  if (isPortal) {
    return /*#__PURE__*/_reactDom["default"].createPortal(TipStyledComponent, portalElement);
  }

  return TipStyledComponent;
}

Tip.displayName = "Popover.Tip";
Tip.propTypes = propTypes;
Tip.defaultProps = defaultProps;
var _default = Tip;
exports["default"] = _default;
//# sourceMappingURL=Tip.js.map